import React, { Component } from 'react';
import Select from 'react-select';

import PaginationArrowIcon from '../../icons/PaginationArrowIcon';

class Pagination extends Component {
  toPrev = () => {
    const { putAssessment, navigate, prevUrl } = this.props;
    putAssessment();
    navigate(prevUrl);
  }

  toNext = () => {
    const { putAssessment, navigate, nextUrl } = this.props;
    putAssessment();
    navigate(nextUrl);
  }

  handlePaginationChange = (e) => {
    const { navigate, currentAssessmentId } = this.props;
    navigate(`/assessments/${currentAssessmentId}/${e.value}`);
  }

  render() {
    const { prevDisabled, textDisabled, questionNumber, totalQuestions, nextDisabled } = this.props;

    return (
      <div className="new-assessment-detail__pagination">
        {prevDisabled ? (
          <div className="disabled">
            <PaginationArrowIcon direction="left" />
          </div>
        ) : (
          <button type="button" onClick={this.toPrev}>
            <PaginationArrowIcon direction="left" />
          </button>
        )}
        <Select
          onChange={this.handlePaginationChange}
          className={'new-assessment-detail__pagination-select' + (textDisabled ? ' new-assessment-detail__pagination-select--disabled' : '')}
          searchable={false}
          clearable={false}
          menuPlacement="auto"
          menuShouldScrollIntoView
          arrowRenderer={null}
          placeholder={questionNumber + ' OF ' + totalQuestions}
          options={[...Array(totalQuestions).keys()].map(index => (
            {
              value: index + 1,
              label: index + 1,
            }
          ))}
        />
        {nextDisabled ? (
          <div className="disabled">
            <PaginationArrowIcon direction="right" />
          </div>
        ) : (
          <button type="button" onClick={this.toNext}>
            <PaginationArrowIcon direction="right" />
          </button>
        )}
      </div>
    );
  }
}

export default Pagination;



// WEBPACK FOOTER //
// ./src/components/features/assessment/Pagination.js